<template>
  <b-container class="massima">

    <loading :active.sync="loading" 
      :can-cancel="false"
      :is-full-page="true"></loading>

    <Menu></Menu>

    <b-row class="mt-5">
        <b-col sm="12">
            <h3>Le ultime massime inserite</h3>
        </b-col>
        <b-col sm="12" class="pt-4 pb-4" style="background-color: #008bc0;">
            <b-list-group>
                <premassima v-for="result in massime" :key="result.id" :premassima="result" class="mt-2">
                </premassima>
            </b-list-group>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '../../services/service.js'
import utils from '../../services/utils.js';

import Premassima from './Premassima.vue'
import Menu from './Menu.vue';

export default {
  name: 'massima',
  components: {
    Loading,
    Menu,
    Premassima
  },
  data () {
    return {
        loading: false,
        massime: []
    }
  },
  methods: {
    async getMassime() {
        this.massime = await api.execute('get', 'commento');
    }
  },
  async created() {
    await this.getMassime();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pubblica/UltimeMassime.vue